const onboardTransPath = 'onboard.';
const practiceInfoTransPath = onboardTransPath + 'practiceInformation.';
const commonBtnPath = 'button.'

const practiceInfoFormPath = practiceInfoTransPath + 'formLabels.';
const practiceInfoMsgPath = practiceInfoTransPath + 'msg.';
const practiceInfoMsgErrorPath = practiceInfoMsgPath + 'error.';

const errorPath = onboardTransPath + 'errors.';

const translations = {
    PRACTICE_INFO_TITLE: practiceInfoTransPath + "title",

    // Form labels
    ORGANIZATION_LABEL: practiceInfoFormPath + "organizationName",
    PRACTICE_TYPE_LABEL: practiceInfoFormPath + "practiceType",
    PRACTICE_TYPE_SPECIFY_LABEL: practiceInfoFormPath + "practiceTypeSpecity",
    ORGANIZATION_ADDRESS_LINE_1: practiceInfoFormPath + "addressLine1",
    ORGANIZATION_ADDRESS_LINE_2: practiceInfoFormPath + "addressLine2",
    CITY_LABEL: practiceInfoFormPath + "city",
    STATE_LABEL: practiceInfoFormPath + "state",
    ZIP_LABEL: practiceInfoFormPath + "zip",

    // Error messages
    ERROR_ORGANIZATION_NAME: practiceInfoMsgErrorPath + "organizationError",
    ERROR_PRACTICE_TYPE: practiceInfoMsgErrorPath + "practiceTypeError",
    ERROR_PRACTICE_TYPE_SPECIFY: practiceInfoMsgErrorPath + "practiceTypeSpecifyError",
    ERROR_ORGANIZATION_ADDRESS_1: practiceInfoMsgErrorPath + "addressLineError",
    ERROR_CITY: practiceInfoMsgErrorPath + "cityError",
    ERROR_STATE: practiceInfoMsgErrorPath + "stateError",
    ERROR_ZIP: practiceInfoMsgErrorPath + "zipError",

    VALIDATION_ERROR : errorPath + 'errorType1',
    VALIDATION_ERROR_LOGOUT : errorPath + 'errorType2',

    SUBMIT_BUTTON_LABEL: commonBtnPath + "submit",
    BACK_TO_PROFESSIONAL_BUTTON_LABEL: commonBtnPath + "backToProfessionalInfo",
    LOGOUT_BUTTON_LABEL: commonBtnPath + "logout",
}

export default translations;